import AutorenewIcon from "@mui/icons-material/Autorenew";
import { ROLES_ID } from "config/roles";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { Add, Dvr, ManageSearchOutlined } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import CustomMenu from "components/CustomMenu";
import { useEffect, useState } from "react";
import NullCheck from "components/NullCheck";
import DisplaySettings from "./components/DisplaySettings";
import { setOpenCreateServices } from "store/servicesCallSlice";
import {
  Box,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { COLORS } from "config/const";
import CustomIconButton from "components/CustomIconButton";

const Header = ({
  employeeId,
  setEmployeeId,
  getCallsList,
  employeeslist,
  setDisplaySettings,
  setTextSearch,
  textSearch,
  showNewCall,
  isActive,
  setSelectedSt,
  selectedSt,
  setSelectedColor,
  selectedColor,
  STATUS_LIST,
  itemsList
}) => {
  const { bt } = useBizTypeTranslation();
  const dispatch = useDispatch()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const user = useSelector((state) => state.userSettings?.user);
  const [openDisplaySettings, setOpenDisplaySettings] = useState(false);
  const [colorList, setColorList] = useState([]);

  useEffect(() => {
    let newList = []
    itemsList?.map((item) => {
      const hasColor = newList.some((color) => color.id === item.color)
      if (item.color && !hasColor) {
        newList.push(COLORS.find((color) => color.id === item.color));
      }
    })
    setColorList(newList);
  }, [itemsList]);

  const menuOptions = [
    {
      title: "NEW_CALL",
      icon: <Add />,
      show: showNewCall && user?.userRole !== ROLES_ID.EMPLOYEE,
      onClick: () => dispatch(setOpenCreateServices(true)),
    },
    {
      title: "IMPORT_CALL",
      icon: <AutorenewIcon />,
      show: true,
      onClick: () => getCallsList(),
    },
    {
      title: "DISPLAY_SETTINGS",
      icon: <Dvr />,
      show: true,
      onClick: () => {
        setOpenDisplaySettings(true);
      },
    },
  ];

  return (
    <Stack
      width="100%"
      direction="row"
      justifyContent={{ xs: "center", md: "space-between" }}
      py={{ xs: 0, md: 2 }}
    >

      <Stack width="100%" direction={{ xs: "column", md: "row" }} spacing={{ xs: 1, md: 2 }}>

        <Stack direction="row" justifyContent="space-between" spacing={{ xs: 1, md: 2 }}>
          <Stack direction="row" spacing={{ xs: 1, md: 2 }}>

            <NullCheck valueForCheck={STATUS_LIST} >
              <Select
                sx={{ width: 130, bgcolor: "bg.main" }}
                size="small"
                MenuProps={{ PaperProps: { style: { maxHeight: 250, width: 120 } } }}
                value={selectedSt}
                defaultValue={'all'}
                onChange={(e) => setSelectedSt(e.target.value)}
              >
                <MenuItem value={"all"}>
                  <Typography>{bt("ALL_CALLS")}</Typography>
                </MenuItem>

                {STATUS_LIST?.map((st, index) => {
                  return (
                    <MenuItem key={index} value={st?.id}>
                      <Typography>{st.title}</Typography>
                    </MenuItem>
                  );
                })}
              </Select>
            </NullCheck>

            <NullCheck
              valueForCheck={user?.userRole !== ROLES_ID.EMPLOYEE && employeeslist?.length > 1}
            >
              <Select
                sx={{ width: 130, bgcolor: "bg.main" }}
                size="small"
                MenuProps={{ PaperProps: { style: { maxHeight: 250, width: 120 } } }}
                value={employeeId}
                defaultValue={'all'}
                onChange={(e) => setEmployeeId(e.target.value)}
              >
                <MenuItem value={"all"}>
                  <Typography>{bt("ALL_EMPLOYEES")}</Typography>
                </MenuItem>

                {employeeslist?.map((emp, index) => {
                  return (
                    <MenuItem key={index} value={emp?.id}>
                      <Typography>{`${emp.fn} ${emp.ln}`}</Typography>
                    </MenuItem>
                  );
                })}
              </Select>
            </NullCheck>

          </Stack>
          {isMobile ? <CustomMenu options={menuOptions} /> : null}
        </Stack>

        <Stack direction={{ xs: "row-reverse", md: "row" }} gap={1} alignItems="center">

          <Select
            sx={{ width: 60, bgcolor: "bg.main" }}
            size="small"
            MenuProps={{ PaperProps: { style: { maxHeight: 250, width: 120 } } }}
            value={selectedColor}
            defaultValue={'all'}
            renderValue={(selected) => {
              return (
                <NullCheck valueForCheck={selected !== "all"}>
                  <Box sx={{
                    width: 16,
                    height: 16,
                    bgcolor: selected,
                    borderRadius: "50%",
                    border: "1px solid",
                  }}></Box>
                </NullCheck>
              )
            }
            }
            onChange={(e) => setSelectedColor(e.target.value)}
          >
            <MenuItem value={"all"}>
              <Typography>{bt("ALL_COLORS")}</Typography>
            </MenuItem>
            {colorList?.map((color, index) => {
              return (
                <MenuItem key={index} value={color?.id}>
                  <Box sx={{
                    width: 80,
                    height: 16,
                    bgcolor: color?.id,
                    borderRadius: "10%",
                    border: "1px solid",
                  }}>
                  </Box>
                </MenuItem>
              );
            })}
          </Select>

          <TextField
            sx={{ width: { xs: "100%", md: 400 }, borderRadius: 3, bgcolor: "bg.main" }}
            onChange={(e) => setTextSearch(e?.target?.value)}
            placeholder={bt("SEARCH")}
            value={textSearch}
            InputProps={{
              endAdornment: <ManageSearchOutlined
                sx={{ color: textSearch !== "" ? "primary.main" : "primary.text" }}
                fontSize="small"
              />
            }}
          />

          <CustomIconButton
            icon={<Add sx={{ color: "bgPage.main" }} />}
            onClick={() => dispatch(setOpenCreateServices(true))}
            size={35}
          />

        </Stack>



      </Stack>

      {!isMobile || !isActive
        ? <CustomMenu options={menuOptions} />
        : null
      }

      <NullCheck valueForCheck={openDisplaySettings}>
        <DisplaySettings
          setDisplaySettings={setDisplaySettings}
          open={openDisplaySettings}
          isActive={isActive}
          setOpen={setOpenDisplaySettings}
        />
      </NullCheck>
    </Stack>
  );
};
export default Header;
